module.exports = __webpack_public_path__ + "assets/img/ambulance-m.72e7496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/ambulance-m.jpg
// module id = 7rD+
// module chunks = 0